export const Bio = {
  name: "Manju Reddy",
  roles: [
    "Senior Full Stack Developer",
    "Mobile App Developer",
    "React Native Specialist",
    "Web Developer",
    "MERN Stack Developer",
    "AI Application Developer",
    "Cloud & API Engineer",
    "SaaS Platform Engineer",
  ],

  description:
    `I help businesses design and build scalable, high-quality digital products—from modern web and mobile applications to cloud-ready backend systems. With 8+ years of full-stack experience, I deliver clean, reliable solutions that scale with your business and provide exceptional user experiences.`,
  github: "https://github.com/manjureddy97",
  resume:
    "https://docs.google.com/document/d/1r7wHimKtfR8JULs6XTX-l1RdQnEWlS08ljsQ-LVXR_o/edit?tab=t.0",
  linkedin: "https://www.linkedin.com/in/manju-reddy-01abba213/",
  twitter: "https://twitter.com/ManjuReddyc97",
  insta: "https://www.instagram.com/manju_boini/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "React Native",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      // {
      //   name: "Angular Js",
      //   image:
      //     "https://camo.githubusercontent.com/8886130b3d8aba95dbdd7c4f9a41029606424cc06d1873c1ced87dd55a222fef/68747470733a2f2f616e67756c61722e696f2f6173736574732f696d616765732f6c6f676f732f616e67756c61722f616e67756c61722e737667",
      // },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
      // {
      //   name: "Flutter",
      //   image:
      //     "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      // },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAY1BMVEWCgoL////l5eXk5OTm5ubu7u74+Pj19fXx8fH7+/vr6+t+fn52dnZ7e3t8fHzz8/OGhoaTk5Pa2tq3t7e7u7utra3Q0NCZmZnFxcWkpKSMjIzKysqpqanX19e/v7+dnZ1ra2tH/Sn9AAASPElEQVR4nOVdbZuyKhBWwTcErcxqa7fO//+VB9RKGF6tdvWc+bLPNY+m48DMzc0AURzHWYKTjP9FOEn5nzTBaKJNPLW5UYtxQozawqYtH1o8V4ui/4eFKEG9hcn4fgmaqU2S0ZaHNndpi0Fbjlr8Ni0atVGWZXmapjn/y/8U/E/B//6etnmnttFoI/4BemcgxUVBWuLS8iaES/6XENLwPw1vSpPPngzXPj67TYtDtIhrI6ztZm/pkuKZDbcpLgt0uV73+7b74tJ1bdterztUZDgl5Se6JJpoP+ZD/uNNnKNTdztHlFJWV7LUjCuj8609oIx/hfRzPvxI3yqanBzaIzeNGxbZpKq4pdG2PeBcdKKXepyhH747lgotut4iyuymKYYyGt1O6aRpvi+WvrXzYZKSXbehDscZrKxp1F1wms7sfNZ8iAa/oLGbIeSjJRrt9RjmO+hLtj31HkDD+6GhS6Kxm3losaKNAs0yG9uQ042+Yt1dano8lS+ahT6QLUjH2BvMG42sOxKTt2WLV8MLwqT42b7FfU+p6PYkUunrQSd6PUU0pK3e576nsKgl8euJQ84W4ck/IWj/UmyxScW+EQlO/gi9M1vkqPuYfYONXfGWbDHbh+1H7Rts3AdCNUX7Qj/M8lNUf9g+IXV0KssX+uH8WIo2n4gvOmFnFAjVprF0bj7Mvukv2SeEfudkbj6cBdUScnhz/nMJ745kHoCbh0uz2286cBB2K3NvqDbFpeHZAse/7cBBKnpKfZvmS1wbSY6/78BB2FGid/wAXPAYvznMGvy9R6rqEH+Ya0ua6185cBDaEm1eQO/i2vDxt3KgSdgRuUmA2Vwb2W3+roXepdqgIAAX0g/zw187cBB2yD/DtaXt33bBp/DO6IBqs0ZP6dcyPCiEfZXeAM4b0xTH3xhH+Aq72aHaFNP4RRqcnP8+xkylOqO3ZguMFhBEZRlCqgmqhXJtJdr8tUE6yd/GtZVkaQ4cJS0n75tqE0fqw7VhtFADo2j3Fq4NL7OJ9rJ5C9eWLNdAHlHdAM7ZD/OFpQlZqm2hQrU8kGtLj0s2kJt4dAE4Rz5Mv5aEZHRS6wCcP9eWt8vBoiahJzuAs0YacljKaMIm9IKtkcaWLXbL96AQtsMWAGcZHyZ4wXlCkk0410Z6Vm3hYfQp1TZWoJoX19Zc19FGhbCOhI+e8M8aosxd6CGYa8PJX790mFTBXFu8mk44SHUsIdeW27i2VWTCqdALCeHakmxtBnITrflQ5drIbV1ttJctCeDaVtdGhdCDPtLossUK26gQmjW+XNv3Ctsol+o7s3NtZEwcGVqnC7kTf0YriJ1ry9cCuKGc/bi203rwqCrs4sW1/fVrviKVB9fWtEtnZmxSt42La0vQetuoELZzcW2kW2emuEvVObm2dbtQpH0719bs1+1CkfaJbWyBydpdyIONNVuQdu0u5E5sCeTaSErEGJ+kxfoN5CYWI9c2ADh59PQT3EjF4roqOh+3x/OG/5u5y/oAJvT9qup1GwO6ZD+xmWvbej5sfCSj5/ZARAMfJCM/+1tlLz5lRawI8QP61Zd649Fw5TZOTFyb57PGV2VfP6X6UCGojay/A27wI2Yr9TbjrBFFyXQEnOcj15ZnTUC2p+eDzrpRdluzjdAX8dbjuTRRbjLzuVVX5gPXlitcm3+qoEdksa935Nn4Y/SiXty42w5rlXtyy8uy2JAPfYdNbLNz2CfkZHxtmqrXXpxPPqu32PzODgau7eZnIL162Ce+4tk0StmAa13tlKrxyTp1W91kru1BknrFmaqv8PCTzvCL9bd6pYP7omqn3zmuR4lubHH1iTMUxgmLXAwvAt7YEjciTXDKHK262uPHngVPH6am9CK92j7EQPO3Zo16pY2DBoni7HrPSYUGH+OTYYzvkwxhGJxrIogcpZlaoGrgdtdPUJJDrs1j0h42LrcYmh+I/uauBS51dML+nl0Os4U73fd1HUDK5HDat/vrAWW6/zZlDQoyjomHVt1ty4R3qbocjp6cLCnr4Ovj9nzf1YND8HOrAg8hX/o3ZwDy6R8LEoUPAoo2mcy1cZDjJLqrLXj3n7OCsistmNN/O/h72lcAXd+viIlibpTEtRVO+oKpjRCddW+kATzY0BUBcuhgtBHJWxKPTtj/uPgwUj5sDG3pIaDfGFdfwJRpYA5AjNRkgUppy65M+LhPgAqJa8t97phIaUbWfKiqAk/TtaqFIGOBj+DVCe+/PeXasCsbKnGhtI/M1RczLCcCTTDeyxeCRLH3H/7s5P3asGNJk9pnXNQDxfL1hkANEYTcTtVE4dkJhdQnOVs4SbbQtkJlWGYigKgK49OpDWqi8O2EQqqWTLk20thBKZNzgE/AVj6/6TIwkJoMUoGH/Tshl2Mjc232q2Xo6zXMUrrQyQA71Qg2YcNALw0s55W5Nvv4rJZ7oRPZ9yI3sdKYW1SIkN+vVEFPQCfsfziXuDY7oqH59EmepSiKC4zVDwCVjYNKNR6XgVwuv//OteV52pgake5d/VyoRhHz0AUMpPqSOpAoQgvt6lPT2zbEUvusIZPgjHdjUbqY0UKA6HtvqXYH19RX3VAbPeRDYiWhqPQoF7ybvLrnffRHsYb3AzWNzKiAuZGnhYjYWp7Ckvh/Sya9uYUxrKV+Lr6GmihCO6GQ82jhEEttV9bSwDcgolVS80vNN4KBVKkmiqBMeJfp2MIYy4XIDSZkklhOo5YLmYPg8oej0x8tJ1xbYbNQ7k4hdZkydLPdCQdSU5lXhkaLwYeEkKK0/sRRelpISZgchK3eB4ThRLJ5FT4MpYSk5RBLbfMGlZyYgibgpHhhnX6t5O8oycyS8/7pYyzFV8tXklF3wzb+EkndyxJqxGO0RJ6Ques+6v3UQttEjmsizVcsnK8QMJAaZXYtaHWNH1xbaesicC5srji6MJyR6r/L7OKJ6ppz2/IhllotfJeBrioBzeRwPLsTit/bk2c+tI3w32ehk87TcK0vLL7iFj65Nhvwrt9mobMcSdMVZ9snIBV5cG3E9nX13WOOOOGQpp3aA7D718ZY+ksWWgeh/TvpbpptYj+svVtoA1RggDpbXPUIeug2O9TcLRR8VGHz4fv6ocNCOKXYiyONWiz8ikWx3sDT2CIN0z53loX2dzU1lrkp/x5p+mxhs1DOFqL8dqZgeywFjNRDunkZo+rSJ9dmzYfSAJz8Q2eL3UDLDLov96VYyDP+nWtrbBYyaQrihehtfx0wSfPyQ6s2e3Bt1vYjD/I+ZqHFQHNdjv0nReTyGVvINI2V75gvgP5VTJyz4vM+thgstI2AZTrzIxaqiaJQYcacEUY9+rCPpdZamvkshreoiWILaq9mpAy2688eGCy03i8nRJ/asFBRh6AnBkF4+D4yFBFPrk1OVB9YNaTSv31BLcj/wSmDNhOuzTq55k1dzxSQKHpbAIXqUUgsC82eXBvC1jeQwkBQtbuXqIliDHugnQanjOnMTGptAnKDmWuISdRCnUfGBe00MGWcpZkZ+9yTVA0V0hHZVAyXqCOKs/F/Aj/ubfRhURRNXlpBsdwRDTVc2hsvu4noiSjVU5MpCrVkJSxlVG3JbbtzbaaSnvFamVzwX1gj5xntJWqikLu56sSQGRp2kOra7F9HflP/SWDpy2hDFFMLSqSAUIN6z4BlS2Ief1LXZq/FkJup92PkGKJjaUCiUJwEeI2AlMGjx7OuLcHEfrUM3HzHFzK41IEhlSGBfVx1YsCeJESU85bJ3UI7GFN6ix//JY9pdRVboKITJK0KtFPvMoIjCalrUx/ks5uiMl+mwUKgm2mwJ+TfPA2c1rWVOQc3jtpEqtQS+MyrO9wDE4U+D6kW+i3t4TFMrCEts0ddmyPLgfIz5wkClVw0rQnAYFJLOzCD8dQvZYgZdmkNqatGGGRf05qm0b6NUhUO469viTpsp36xPFbWkDYu0AdQ4o/lMCtQ6g1dCBKFOSWrT8492ulQ5/3g2ji4yVyTCrCyPm4N/CCLADMIG6Baom4mD2A79UgZ9bXhiE3Y9lhR4kxymqmvvGPAkRWN4Iw83C8Flv5b1j2B9Q3ulEF3GKwKchMwunXNh+/oeRJuzejmW7O+FDZA4BcrbAT+dqeMTQbXkDpHRZpFM4Mnd5e9OMq42192aoFaLw0MIaBX258M5hVdA5yqfZwNxWMp7tcfYjc9UQetrnwKbB2gxTs+L2ynjtlvdhlOXcaTNaQYu9MMm2Ui3BAcLIJzDvzgMjA75mDJzDWkzDa7oJccLs2AcxTOB8Nb7CsTpmtIB66tLEjqnITmUp/1iwyNomsZteoQD2IEVNlaU0Z9SnNu1IRrG3Yc8Bsx+KzFf4huFAJ+wWtIDdvptyW/GHYc8FuPT8EKCaPkuhPaYAL3eqxm+s2Y3/r1+LodeDz3VKgA9WCQkxbzgEThSd7BdmpMGYKTePqw59rynGOcwrsmgG08ljxfIu0HA4nCm/aB7dSUMmg+GDXl2ob92vypUFZdtcn9LunecAgySBT+82bem6KIzbAM+7WFMPbifHBDvSQ+Gc+whoWyATuJwnaqJ9Aowsb92sL2GKppddwfyMSZOTmITYYsrV19x6DFTGApcqzdXm4bg/3a7uePkfBtL8UidVZtztvteRP1/7b65HzcyhL2tI1y91aHUtipX7rN/RhPuLZxvzYHqbgS+d/t11aWgmsjOf/L/6Tr33OPCahWlg23JisnXNu42/VaN0l+ipjPtZ6N8B/Z+9JyNgJZuRN7jk3esXzk2sY/Ta6hHNYkrCgGa5pC5dri+9kItvUzi5f66nM2wpqbaeV1NsLa9/NWz0Z4cG09yBFbZJTzClaXIBsyQjWMn7EUno1gX424ZKE/WDkbQbPbNcK8wfov116UiLMR7hYihWsry4L/fQA4n920Figsf0C1Jwwt5WwxJn+yosOsnsLGrQS9ziFNV3nOTBpyDumHyrk/KfTR+RQfTri2CYDLV5cU2amUrNBzbRN3ktWd2dXEmlPJrOeQ/vU7B0oSfA4pXtWZT/ez80znkHJbe65NAnAzquP/TEQZhQTVjFybfJjHarpiP/8uQTWQLTDSWJgs+bxqSTYAqk0tlLk2CcClazlLFqUqVDNzbUryX0W0EdMZKlTzOYc0WdWZzrZTq60+TMnX0k1kw7ncifkcUhnkKACuycuFY/DqFuugmpVrUwEcLIdZkFRnPVTzPZd7mHNbcs7YTDpfEnIOqQzg/toMi5igmoVrGwGcpHXVD/+dZCXWQjVs59pgg13qIUm5Eaq5uDbVwnKJDbXiBhqhmotrgwAOb5bmxuqMSzNUc3FtcvIf4s/CkoZIExaoFpYtBm0xa3PGT0l9hHnBmi2sPrwDuNtyABy7OaCamWtrLAAu3i9lpEH3LqjmwbWNWtmd12WYKBbFOaCaF9em0ZKfJfTFeufufD5cm1aLkfGUqt8Sdu7fzAHVDFybB4CLy++/bam0Hd5MhmpYhWoTrSVbID0D9/5tIwKk3yzHA6r5cW0GLbEci/dhYVuEVVCmh2qeXJsEiCba8o/SBt0X/Ttk2jcL5dqQTUt2f+BGdu6PzEy8oJo316YHcFxL9HX4n5OKtinW5AWPbGHn2sza/PabTZXeUqIHZU5tZIRqDm2TGZYbfEBYdMkAiNRDS6jVcW2q4wzaIr5algK/Typ2JcQIyt7BtVm0PP9/2saKdplf53uBazNoxe/ku9tHbazokUwDqATK9FoL1yaSKYRqd21u0hZfH7OR+6+IG/AOE1DmAeAgE2UBcIlWS1BHPxFzatohXQbwgWqhXJtdy7Njetm82ZEV3Vwx8QBl7+LaTADufm0c777e6EhGv3ZxagNlZqimal+MNA9tgsv4YFzQFSQ8uhxSgsNjiiHSvJQtplrx62i/pS/lyKqm22s2Ly+8zLX5aHmXJGKXhXqOlVXFou6EyDCE9wVl7+HaQrR5nmXodItYkJUVo9HtuhNbbweCMqfWiLyDAJxGuzt9b/stM5ztkhu37U48WDV4Bih7L9cW0iV5b2jiHJ262zmilD12B6meu4RQGp2P3QWJ0Jc+u87zF5LZnW821+YVViVtI5Ja2aDLdb/ft93X7fbVdW3b7q871GT8P6VRrQcoCw6req5tJoC7ayGk6ktXSJ/BY5KSHgoRy7VWUBYG4KxMVBCAy21aArVyI9RrZ0O1l7g2K4BLVG0+aIlR+yoo+wjX9prWC369rn0AuE9HmlTu+3rtRyPNv+c/cIe0nzmlAAAAAElFTkSuQmCC",
      },
      {
        name: "Graph Ql",
        image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      // {
      //   name: "Flask",
      //   image:
      //     "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Flask_logo.svg/1280px-Flask_logo.svg.png",
      // },
      {
        name: "Django",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSlFFyY16N5NRhzoG24RqB7x8Ok2t8Bdgs-tuMsOBXS2Q&s",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "DevOps",
    skills: [
      {
        name: "AWS",
        image:
          "https://download.logo.wine/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.png",
      },
      {
        name: "Google Cloud",
        image:
          "https://static-00.iconduck.com/assets.00/google-cloud-platform-logo-icon-2048x1824-pg4wzspq.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Jenkins",
        image:
          "https://toppng.com/uploads/preview/jenkins-logo-11609365847mufysaivph.png",
      },
      {
        name: "Nginx",
        image: "https://download.logo.wine/logo/Nginx/Nginx-Logo.wine.png",
      },
      {
        name: "LLMs / AI Systems",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/6/6a/OpenAI_Logo.svg",
      },
      {
        name: "RAG Pipelines",
        image:
          "https://raw.githubusercontent.com/langchain-ai/langchain/master/docs/static/img/langchain.png",
      },
      {
        name: "Vector Databases",
        image:
          "https://qdrant.tech/images/logo_with_text.svg",
      },
      {
        name: "Grafana",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a1/Grafana_logo.svg/1200px-Grafana_logo.svg.png",
      },
      {
        name: "Kubernetes",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/0/00/Kubernetes_%28container_engine%29.png",
      },
      {
        name: "Prometheus",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Prometheus_software_logo.svg/1200px-Prometheus_software_logo.svg.png",
      },

    ],
  },
  // {
  //   title: "Android",
  //   skills: [
  //     {
  //       name: "Java",
  //       image:
  //         "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
  //     },
  //     {
  //       name: "Kotlin",
  //       image:
  //         "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
  //     },
  //     {
  //       name: "Jetpack Compose",
  //       image:
  //         "https://3.bp.blogspot.com/-VVp3WvJvl84/X0Vu6EjYqDI/AAAAAAAAPjU/ZOMKiUlgfg8ok8DY8Hc-ocOvGdB0z86AgCLcBGAsYHQ/s1600/jetpack%2Bcompose%2Bicon_RGB.png",
  //     },
  //     {
  //       name: "XML",
  //       image:
  //         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
  //     },
  //     {
  //       name: "Android Studio",
  //       image:
  //         "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
  //     },
  //   ],
  // },
  // {
  //   title: "Machine Learning",
  //   skills: [
  //     {
  //       name: "Python",
  //       image:
  //         "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
  //     },
  //     {
  //       name: "Tenserflow",
  //       image:
  //         "https://static-00.iconduck.com/assets.00/tensorflow-icon-1911x2048-1m2s54vn.png",
  //     },
  //     {
  //       name: "Keras",
  //       image:
  //         "https://miro.medium.com/v2/resize:fit:600/1*DKu_54iqz6C-p6ndo7rO3g.png",
  //     },
  //     {
  //       name: "Jupyter",
  //       image:
  //         "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Jupyter_logo.svg/1767px-Jupyter_logo.svg.png",
  //     },
  //     {
  //       name: "Google Colab",
  //       image:
  //         "https://assets.stickpng.com/images/63c2e4c9c4baad4ce22bf9ef.png",
  //     },
  //     {
  //       name: "Sk Learn Kit",
  //       image:
  //         "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Scikit_learn_logo_small.svg/2560px-Scikit_learn_logo_small.svg.png",
  //     },
  //   ],
  // },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://static-00.iconduck.com/assets.00/postman-icon-497x512-beb7sy75.png",
      },
      {
        name: "Adobe XD",
        image:
          "https://camo.githubusercontent.com/c205ecbe12500177d102169d97bc1c17c545155fdf5ec78c08d54ac53e5b38c1/68747470733a2f2f63646e2e776f726c64766563746f726c6f676f2e636f6d2f6c6f676f732f61646f62652d78642e737667",
      },
      {
        name: "Figma",
        image:
          "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://content.jdmagicbox.com/comp/hyderabad/k4/040pxx40.xx40.190323001528.n4k4/catalogue/blueihub-it-services-pvt-ltd-begumpet-hyderabad-internet-website-designers-r0rw18dafb-250.jpg",
    role: "Software Engineer",
    company: "Bluelhub",
    date: "Apr 2018 - June 2021",
    desc: "Enhanced user experiences on Bluelhub PSG & Hybrid Portals by resolving critical bugs and reducing load time by 40%. Developed responsive UI components using HTML, CSS, and Bootstrap. Built Bluelhub Analytics portal using React JS with seamless REST API integration using Axios. Collaborated with design team using Figma to implement pixel-perfect interfaces. Participated in code reviews and implemented best practices for front-end development.",
    skills: [
      "HTML",
      "CSS",
      "JavaScript",
      "BootStrap",
      "React Js",
      "Figma"
    ],
  },
  {
    id: 1,
    img: "https://media.licdn.com/dms/image/D4D0BAQFYdIpi7JwEMA/company-logo_200_200/0/1706010439878/seasia_infotech_logo?e=2147483647&v=beta&t=ZIo8IX0iWGfcwT--SeBOm1jouin_0DQ4jizpwzjbWi8",
    role: "Software Developer",
    company: "Seasia Infotech, Mohali.",
    date: "June 2022 - Mar 2022",
    desc: "Led development of cross-platform applications using React JS and React Native with TypeScript. Implemented state management using Redux and context API. Built RESTful APIs with Node.js and integrated GraphQL to optimize data fetching, reducing API calls by 20%. Collaborated with UX/UI designers to implement responsive interfaces. Wrote clean, maintainable code following industry best practices and participated in code reviews to ensure quality.",
    skills: [
      "React Js",
      "React Native",
      "JavaScript",
      "TypeScript",
      "Node Js",
      "Python"
    ],
  },
  {
    id: 2,
    img: "https://media.instahyre.com/images/profile/base/employer/29611/0268b3939c/logo_resize.webp",
    role: "Senior Engineer",
    company: "Truequations .",
    date: "Oct 2022 - Mar 2022",
    desc: "Led development of cross-platform applications using React JS and React Native with TypeScript. Implemented state management using Redux and context API. Built RESTful APIs with Node.js and integrated GraphQL to optimize data fetching, reducing API calls by 20%. Collaborated with UX/UI designers to implement responsive interfaces. Wrote clean, maintainable code following industry best practices and participated in code reviews to ensure quality.",
    skills: [
      "React Js",
      "React Native",
      "JavaScript",
      "TypeScript",
      "Node Js",
      "Python",
      "Django"
    ],
  },
  {
    id: 3,
    img: "https://media.licdn.com/dms/image/C560BAQGFUXFOrwA4sA/company-logo_200_200/0/1630561994394/riser_techub_logo?e=2147483647&v=beta&t=8Ml65wHqwsjjWMNgNzzRrb2m901m1MNT0VRIER-0KSM",
    role: "ReactNative Developer",
    company: "Riser Techub, Pune",
    date: "Mar 2022 - June 2022",
    desc: "Developed and maintained cross-platform mobile applications using React Native. Created reusable components and implemented Redux for state management. Built a full-stack employee management web application with React JS frontend and Node.js backend. Containerized the application using Docker and deployed on AWS EC2. Implemented responsive UI designs using Material UI and custom CSS. Recognized as the top performer for delivering high-quality code ahead of deadlines.",
    skills: [
      "ReactJS",
      "React Native",
      "Redux",
      "NodeJs",
      "Material UI",
      "HTML",
      "CSS",
      "JavaScript",
      "Docker",
      "AWS",
      "MongoDB",
    ],
  },
  {
    id: 4,
    img: "https://media.licdn.com/dms/image/C4E0BAQEr40qQwS1DmA/company-logo_200_200/0/1630572952269/natsoft_logo?e=2147483647&v=beta&t=ZOFnorJMS18B9okXuhMIiMCH7rajsrh1fV620E34XUc",
    role: "Senior Software Engineer",
    company: "Natsoft",
    date: "Jul 2022 - July 2023",
    desc: "Led development teams in creating responsive web and mobile applications using React JS and React Native. Implemented complex UI components with Material UI and custom CSS. Mentored junior developers and conducted code reviews to maintain code quality. Collaborated with product managers to translate business requirements into technical specifications. Implemented state management solutions using Redux and Context API. Improved application performance and user experience through code optimization.",
    skills: [
      "Leadership",
      "Mobile Application Development",
      "Web Application Development",
      "ReactJS",
      "Next.js",
      "React Native",
      "Redux",
      "TypeScript",
      "Node.js",
      "Python",
      "FastAPI",
      "Django",
      "REST API Development",
      "AI Application Development",
      "LLM Integration",
      "RAG Pipelines",
      "Vector Databases (pgvector, Qdrant)",
      "AI Search & Retrieval",
      "Cloud Computing (AWS, Azure, GCP)",
      "Docker",
      "Kubernetes",
      "Observability & Monitoring",
      "Grafana",
      "Prometheus",
      "Datadog",
      "Material UI",
      "HTML",
      "CSS",
      "JavaScript"
    ]


  },
  {
    id: 5,
    img: "./Aaron.png",
    role: "Senior Software Engineer",
    company: "AaronSoftware",
    date: "Jul 2023 - March-2024",
    desc: "Architected and developed enterprise-level web and mobile applications using React JS and React Native. Led front-end development initiatives and implemented responsive designs with Material UI. Established coding standards and best practices for the development team. Implemented efficient state management using Redux and Redux Toolkit. Collaborated with UX/UI designers to create intuitive user interfaces. Conducted technical interviews and mentored junior developers to foster team growth.",
    skills: [
      "Leadership",
      "Mobile Application Development",
      "Web Application Development",
      "React JS",
      "React Native",
      "Redux",
      "Node.js",
      "Python",
      "API Development",
      "AI Application Development",
      "LLM Integration",
      "RAG Pipelines",
      "Vector Databases",
      "Cloud Computing",
      "Docker",
      "Kubernetes",
      "Grafana",
      "Prometheus",
      "Material UI",
      "HTML",
      "CSS",
      "JavaScript",
    ]

  },
  {
    id: 6,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTsO0DpltfzxawXnJJMIZjtWVaYECVq5maT9A&s",
    role: "Senior Software Engineer",
    company: "BDNT Labs",
    date: "March 2024 - Aug 2025",
    desc: "Leading product development initiatives as a Full Stack developer, architecting scalable solutions using modern technologies. Developing high-performance web applications with Next.js, React, and Node.js. Building cross-platform mobile applications with React Native. Designing and implementing RESTful APIs and database schemas using Express.js with MongoDB and PostgreSQL. Deploying and maintaining cloud infrastructure on AWS. Implementing CI/CD pipelines for automated testing and deployment. Mentoring junior developers and conducting code reviews to ensure code quality and best practices.",
    skills: [
      "Product Development Lead",
      "Mobile Application Development",
      "Web Application Development",
      "React JS",
      "React Native",
      "Redux",
      "Next Js",
      "Material UI",
      "HTML",
      "CSS",
      "JavaScript",
      "Node Js",
      "Express Js",
      "MongoDB",
      "Postgresql",
      "Firebase",
      "Python",
      "Django",
      "FastAPI",
      "REST API Development",
      "AI Application Development",
      "LLM Integration",
      "RAG Pipelines",
      "Vector Databases (pgvector, Qdrant)",
      "AI Search & Retrieval",
      "Docker",
      "Kubernetes",
      "Grafana",
      "Prometheus",
      "Datadog",
      "AWS",
    ]

  },

  {
    id: 7,
    img: "https://www.greatplacetowork.in/great/api/assets/uploads/8860/logo/logo.jpg",
    role: "Senior Software Engineer",
    company: "Coforge",
    date: "Aug 2025 - Dec 2025",
    desc: "Worked as a Senior Software Engineer on large-scale enterprise applications for global clients, contributing across the full software development lifecycle. Developed and enhanced responsive front-end applications using React and modern JavaScript frameworks. Built and maintained backend services using Python (Django, FastAPI) and Node.js, implementing secure and scalable REST APIs aligned with business requirements. Collaborated with architects, QA, and DevOps teams to design reliable system components, improve application performance, and ensure production stability. Supported cloud deployments on AWS, participated in CI/CD processes, and worked with monitoring and observability tools such as Datadog to maintain high availability. Actively participated in code reviews, agile ceremonies, and team mentoring, ensuring code quality and adherence to enterprise best practices.",

    skills: [
      "Enterprise Application Development",
      "Web Application Development",
      "React JS",
      "Redux",
      "JavaScript",
      "TypeScript",
      "Node Js",
      "Python",
      "Django",
      "FastAPI",
      "REST API Development",
      "Microservices Architecture",
      "PostgreSQL",
      "MongoDB",
      "Cloud Computing (AWS)",
      "Docker",
      "CI/CD Pipelines",
      "Datadog",
      "Monitoring & Observability",
      "Agile & Scrum",
      "System Design",
    ]
  },

];

// export const education = [
//   {
//     id: 0,
//     img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Kiit.jpeg?alt=media&token=3839d520-c59d-4341-ad8f-0980c98de4dd",
//     school: "Kalinga Institute of Industrial Technology, Bhubaneswar",
//     date: "Oct 2021 - Sep 2025",
//     grade: "8.41 CGPA",
//     desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering at Kalinga Institute of Industrial Technology, Bhubaneswar. I have completed 4 semesters and have a CGPA of 8.71. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. I am also a member of the Google Developers Student Club (GDSC) at KIIT, where I am learning and working on exciting projects with a team of talented developers.",
//     degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
//   },
//   {
//     id: 1,
//     img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/methodist.png?alt=media&token=018a1b18-e2dd-4f34-8855-cff1b6b69fd3",
//     school: "Methodist School, Dankuni",
//     date: "Apr 2019 - Apr 2025",
//     grade: "88.2%",
//     desc: "I completed my class 12 high school education at Methodist School, Dankuni, where I studied Science with Computer Science.",
//     degree: "ISC(XII), Science with Computer",
//   },
//   {
//     id: 2,
//     img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/methodist.png?alt=media&token=018a1b18-e2dd-4f34-8855-cff1b6b69fd3",
//     school: "Methodist School, Dankuni",
//     date: "Apr 2017 - Apr 2019",
//     grade: "92.3%",
//     desc: "I completed my class 10 education at Methodist School, Dankuni, where I studied Science with Computer Application.",
//     degree: "ICSC(X), Science with Computer",
//   },
// ];

export const projects = [
  {
    id: 1,
    title: "Upadhi.ai (Job Portal)",
    description: "A comprehensive job portal designed to connect job seekers and employers. Features a mobile app built with React Native for Android and iOS, with Redux for state management. The backend is powered by Node.js and uses PostgreSQL and MongoDB. AWS services are used for scalability, and OpenAI is integrated for intelligent job recommendations and matching algorithms.",
    image: "https://media.licdn.com/dms/image/v2/D560BAQFUUEhEdV_Rug/company-logo_200_200/company-logo_200_200/0/1694422873286?e=2147483647&v=beta&t=cLsjPAJa08so4W6Pc8t5FhQnHPox_z_-fuM08GPsrfA",
    tags: ["Redux", "Next.js", "Node.js", "PostgreSQL", "MongoDB", "Jenkins", "SonarQube", "AWS", "OpenAI"],
    category: "web app",
    webapp: "https://upadhi.ai",
  },
  {
    id: 2,
    title: "Upadhi Mobile App",
    description: "Developed the mobile application for the Upadhi.ai job portal. Integrated with AWS for serverless computing, Firebase for authentication, and used OpenAI for personalized job alerts. React Native was used for building a seamless cross-platform experience with Redux and Redux Saga for efficient state management.",
    image: "https://www.upadhi.ai/_next/image?url=%2Fimages%2Flogolightwebp.webp&w=384&q=75",
    tags: ["React Native", "Redux", "AWS"],
    category: "android app",
    webapp: "https://upadhi.ai",
  },
  {
    id: 3,
    title: "MyRingByMe",
    description: "A platform that lets you create custom rings and preview them using augmented reality! For this project, we used React Native on the frontend and Ruby on Rails on the backend. The backend was deployed on Amazon Web Services' ECS (Elastic Container Service) and used a fully managed RDS (Relational Database Service) Postgresql database. The web version was deployed on AWS Amplify.",
    image: "https://images.sftcdn.net/images/t_app-icon-m/p/63348ade-b64f-494f-af93-fc290acd53a8/3332669459/myringbyme-logo",
    tags: ["React Native Expo", "Ruby on Rails", "AWS", "Postgresql"],
    category: "android app",
    webapp: "https://apps.apple.com/mx/app/myringbyme/id1604386189?l=en-GB",
  },
  {
    id: 4,
    title: "Josh",
    description: "Josh is a short video app that lets you watch, share, and create fun and engaging videos and discover your Mojo. Developed with React Native for a smooth user experience across platforms.",
    image: "https://images.sftcdn.net/images/t_app-icon-m/p/351d7ec4-9f8c-4368-9bdb-4f7f0ac543bd/1857296612/josh-short-videos-app-logo",
    tags: ["React Native Expo", "Ruby on Rails", "AWS", "Postgresql"],
    category: "android app",
    webapp: "https://play.google.com/store/apps/details?id=com.eterno.shortvideos",
  },
  {
    id: 5,
    title: "Sparkseeker",
    description: "Helping businesses Supercharge your influence, foster meaningful connections, and ignite positive change with Sparkseeker – the customizable, responsible tech-powered social community app.",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQHoy0t499baqTZaI-slR2IS_4BP_F9NhlOFb932lUat2I9goEwY7HqbYx5aLXP5-_HKc4&usqp=CAU",
    tags: ["React Native", "Node Js", "AWS", "PostgreSQL", "React.js"],
    category: "android app",
    webapp: "https://sparkseeker.com/",
  },
  {
    id: 6,
    title: "MCQ Moc Test",
    description: "This is the application that our team has developed specifically to assist students in preparing for their group exams by providing a platform for practicing mock tests. With this application, students can access a wide range of mock tests designed to simulate the actual exam experience, helping them familiarize themselves with the format, timing, and types of questions they may encounter.",
    image: "https://play-lh.googleusercontent.com/yc4gyBBM03m6tFoOUivkO_ghjxTUEGoqiLJqrTS7BogHKCH_D-SqlzqC-TqA_VQrrUVa=w2560-h1440-rw",
    tags: ["React Native", "JavaScript", "Axios", "Redux", "Android Studio", "Xcode"],
    category: "android app",
    webapp: "https://play.google.com/store/apps/details?id=com.mcq2",
  },
  {
    id: 7,
    title: "Sosin",
    date: "Oct 2022 - Jan 2023",
    description: "SOSIN CLASSES formerly known as TARGET IAS is a Hyderabad based coaching institute that trains Civil Services aspirants to reach their goals successfully. A web app designed to help students prepare for UPSC Anthropology exams through video lectures and periodic tests by Mrs. Sosin Thayyaba Revella.",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTCijQwZAGhDNOj_G6P1CZJcDgyao6LqJ6Or-JrUCCx0S5dGCuwfJRvIlCyryN4_F5WOc8&usqp=CAU",
    tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Redux", "NodeMailer"],
    category: "web app",
    webapp: "https://sosinias.com",
  },
  {
    id: 8,
    title: "Rapid Notifier",
    description: "A  project that provides security alerts through sound notifications. The app was developed for both Android and iOS using React Native with Expo. Features real-time notifications for security alerts and emergencies.",
    image: "https://rapid.sg/wp-content/uploads/2018/09/Rapid-logo-150x150-2.png",
    tags: ["React Native", "Expo", "Xcode", "Recoil"],
    category: "android app",
    webapp: "https://rapid.sg/",
  },
  {
    id: 9,
    title: "Materra",
    description: "Materra is the one-stop nature-based solution for the fashion industry to source fully traceable regenerative cotton, at scale.",
    image: "https://uploads-ssl.webflow.com/65361781723a0955a42be9b3/6620dcf7eeeeee0655e6f9ed_materra%2Bwebsite.jpg",
    tags: ["React.js", "Redux"],
    category: "web app",
    webapp: "https://www.materra.tech/"
  },
  {
    id: 10,
    title: "Dhyeya School of Business Intelligence",
    description: "Dhyeya, School of Business Intelligence, Enterprise Computing and Applied AI research, is dedicated to transforming individuals into dynamic and expert professionals fully equipped to achieve success.",
    image: "https://www.dhyeya.ai/_next/static/media/Dhyeya-Logo.f6319d05.png",
    tags: ["Redux", "Next.js", "Node.js", "PostgreSQL", "MongoDB", "Jenkins", "SonarQube", "AWS", "OpenAI"],
    category: "web app",
    webapp: "https://dhyeya.ai/"
  },
  {
    id: 11,
    title: "Calm and Connected",
    description: "The therapists at Calm and Connected provide mobile, clinical and online support to the adults surrounding a child, and teach the child how to address the foundational skills that affect our ability to connect.",
    image: "https://calmandconnected.com.au/wp-content/uploads/2023/02/CC-landscape-light-1280x332.png",
    tags: ["React.js", "Redux", "Node.js", "PostgreSQL", "MongoDB", "Jenkins", "SonarQube", "AWS"],
    category: "web app",
    webapp: "https://calmandconnected.com.au/"
  },

  {
    id: 12,
    title: "Kisanwala",
    description: "Kisanwala is an agri-tech platform that enables farmers and agribusinesses to rent cutting-edge agricultural machinery such as drones, harvesters, transplanters, and robots on demand. The platform also provides real-time crop price monitoring and future price insights to support informed decision-making. I worked on both web and mobile applications, focusing on building scalable user interfaces, seamless booking workflows, and reliable backend integrations to ensure smooth operations for vendors and customers.",
    image: "https://play-lh.googleusercontent.com/Uo2m-Z76dsOHDJhymYyKsAscMdu5MhiWSIQwDI__5y7vuLfL9QzHAjhkbC3L3LVNB5VS",
    tags: [
      "React.js",
      "React Native",
      "Redux",
      "Node.js",
      "Express.js",
      "MongoDB",
      "PostgreSQL",
      "REST APIs",
      "AWS",
      "Firebase"
    ],

  },
  {
    id: 13,
    title: "Kisanwala Mobile",
    category: "android app",
    description: "Kisanwala is an agri-tech platform that enables farmers and agribusinesses to rent cutting-edge agricultural machinery such as drones, harvesters, transplanters, and robots on demand. The platform also provides real-time crop price monitoring and future price insights to support informed decision-making. I worked on both web and mobile applications, focusing on building scalable user interfaces, seamless booking workflows, and reliable backend integrations to ensure smooth operations for vendors and customers.",
    image: "https://cdn.dribbble.com/userupload/7630914/file/original-a21da86e088a8374f9b80349a931dc3c.jpg?resize=400x300",
    webapp: "https://corporate.kisanwala.com",
    mobile: [
      "https://play.google.com/store/apps/details?id=com.kisanwala&pcampaignid=web_share",
      "https://share.google/KnPf1uQkOG7LjnxXi"
    ]
  },
  {
    id: 14,
    title: "Board Agent",
    description: "Board Agent is an AI-powered governance and decision-support platform designed for board members and executive leadership. The system leverages LLMs and RAG-based pipelines to ingest, analyze, and retrieve insights from board documents, reports, and structured data. I worked on building the full-stack architecture, including intelligent document ingestion, vector-based search, and contextual AI responses to support strategic decision-making. The platform focuses on security, scalability, and explainability, enabling organizations to access accurate insights from complex board-level data in real time.",
    image: "https://cdn-icons-png.flaticon.com/512/4712/4712109.png",
    tags: [
      "Next.js",
      "React.js",
      "Python",
      "FastAPI",
      "LLM Integration",
      "RAG Pipelines",
      "Vector Databases (pgvector, Qdrant)",
      "AI Search & Retrieval",
      "PostgreSQL",
      "Docker",
      "AWS"
    ],
    category: "web app"
  },
  {
    id: 14,
    title: "Scholarship Management Platform",
    description: "A comprehensive scholarship management platform designed to streamline the end-to-end scholarship lifecycle, including applications, eligibility validation, review workflows, and beneficiary tracking. I contributed to developing scalable web interfaces and backend services to handle large applicant volumes, role-based access, and secure data processing. The platform improves transparency, reduces manual effort, and ensures efficient scholarship distribution through automated workflows and real-time status tracking.",
    image: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
    tags: [
      "React.js",
      "Next.js",
      "Node.js",
      "Python",
      "Django",
      "REST APIs",
      "PostgreSQL",
      "Role-Based Access Control",
      "Cloud Deployment",
      "AWS"
    ],
    category: "web app"
  },
  {
    id: 15,
    title: "Dhyeya.ai",
    description: "Dhyeya.ai is an online upskilling and career transformation platform offering expert-led courses in Data Science, Soft Skills, SAP, HR, and other professional domains. I contributed to building scalable web application features focused on course discovery, enrollment workflows, and user engagement. The platform is designed to support high user traffic, secure content delivery, and a smooth learning experience, helping learners upskill and achieve their career goals through structured, industry-relevant programs.",
    image: "https://media.licdn.com/dms/image/v2/D5622AQFfHs5H9S6wXw/feedshare-shrink_800/B56ZpZX6ilH8Ak-/0/1762436034498?e=2147483647&v=beta&t=KlT9AWKQwdFs4Pm0AQVvb5AXOtC07gnbSJfD-MHr9vA",
    tags: [
      "React.js",
      "Next.js",
      "Node.js",
      "REST APIs",
      "PostgreSQL",
      "AI Application Development",
      "LLM Integration",
      "RAG Pipelines",
      "Vector Databases",
      "AI Search & Retrieval",
      "Cloud Deployment",
      "AWS",
      "Authentication",
      "Scalable Web Architecture"
    ],

    category: "mobile app",
    webapp: "https://www.dhyeya.ai"
  },
  {
    id: 16,
    title: "SchoolApp",
    description: "SchoolApp is a comprehensive school management platform designed to digitize and streamline academic and administrative operations. The application supports student enrollment, attendance tracking, timetable management, fee management, examinations, and parent-teacher communication. I worked on both web and mobile applications, building intuitive user interfaces and scalable backend services to support multiple user roles such as administrators, teachers, students, and parents. The platform improves operational efficiency, transparency, and real-time communication within educational institutions.",
    image: "https://www.aaxiomcrest.com/images/stellar_app.jpg",
    tags: [
      "React.js",
      "React Native",
      "Next.js",
      "Node.js",
      "REST APIs",
      "PostgreSQL",
      "MongoDB",
      "Role-Based Access Control",
      "Authentication",
      "Cloud Deployment",
      "AWS"
    ],
    category: "mobile app"
  },
  {
    id: 17,
    title: "ERP System",
    description: "A comprehensive Enterprise Resource Planning (ERP) system designed to centralize and automate core business operations across multiple departments. The platform covers modules such as HR management, payroll, finance, inventory, procurement, attendance, reporting, and role-based access control. I contributed to building scalable web interfaces and robust backend services, ensuring secure data handling, seamless inter-module integration, and high system reliability. The ERP system improves operational efficiency, data visibility, and decision-making for organizations of varying scale.",
    image: "https://images.ctfassets.net/lzny33ho1g45/1FzzuoyZ554G7ApEDxJZJJ/e8f00ca2c12848541ae01a2dee00f003/0aca5b23-e069-40b7-abce-a0fc846cd857.png",
    tags: [
      "React.js",
      "Next.js",
      "Node.js",
      "Python",
      "Django",
      "FastAPI",
      "REST APIs",
      "PostgreSQL",
      "MongoDB",
      "Role-Based Access Control",
      "Authentication",
      "Cloud Deployment",
      "AWS"
    ],
    category: "web app"
  },






];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a software developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
